export const SIDEBAR_MODES = {
  view: "view",
  new: "new",
} as const;

export const SIDEBAR_SECTIONS = {
  users: "users",
  leads: "leads",
  advocates: "advocates",
  technicians: "technicians",
  referralPayments: "referral-payments",
  internalTransactions: "internal-transactions",
  referralHistory: "referral-history",
  textMessages: "text-messages",
  referralSources: "referral-sources",
  reviews: "reviews",
} as const;

export const BUSINESS_SETTINGS_ROUTES = {
  business: "/",
  payments: "/payments",
  referralPayments: "payments/referral-payments",
  internalTransactions: "payments/internal-transactions",
  users: "/users",
  webAppUsers: "/users/web-app-users",
  technicians: "/users/technicians",
  customers: "/customers",
  leads: "/customers/leads",
  advocates: "/customers/advocates",
  referralHistory: "/referral-history",
  textMessages: "/text-messages",
  referralSources: "/referral-sources",
  reviews: "/reviews",
} as const;

export const SETTINGS_PAGE_TITLES: Record<string, string> = {
  "": "Business profile",
  payments: "Payments",
  users: "Users",
  customers: "Customers",
  "referral-history": "Referral history",
  "text-messages": "Text messages",
  "referral-sources": "Referral sources",
  reviews: "Five-star reviews",
};
